// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"e10fa984","364":"f569484a"}[chunkId] + ".chunk.css";
};